import {DOCS} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/docs/index.vue'),
    name: DOCS,
    path: 'docs',
    meta: {
        name: DOCS,
        title: '接入文档'
    }
};